module.exports = "<park *ngFor=\"let park of parks\" [park]=\"park\">No parks</park>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park-list/park-list.html
// module id = ./src/app/dashboard/parks/park-list/park-list.html
// module chunks = main